var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6299 11.6135H15.2061C13.156 11.6135 11.4941 13.2754 11.4941 15.3255V22.7493C11.4941 24.7994 13.156 26.4613 15.2061 26.4613H22.6299C24.68 26.4613 26.3419 24.7994 26.3419 22.7493V15.3255C26.3419 13.2754 24.68 11.6135 22.6299 11.6135Z",
    fill: "#37994F",
    stroke: "#37994F",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9168 21.8211C20.4543 21.8211 21.7007 20.5747 21.7007 19.0372C21.7007 17.4996 20.4543 16.2532 18.9168 16.2532C17.3792 16.2532 16.1328 17.4996 16.1328 19.0372C16.1328 20.5747 17.3792 21.8211 18.9168 21.8211Z",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0938 14.8608V14.8618",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9171,
    cy: 19.0373,
    r: 17.8637,
    stroke: "#37994F",
    strokeWidth: 1.39198
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_12991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2716,
    height: 22.2716,
    fill: "white",
    transform: "translate(7.78125 7.90125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d56537d86850e76f34487bdd09b8a013.svg";
export { ForwardRef as ReactComponent };